import { EntityPermissionCoreBase } from "./entity-permission.core.base"


export class EntityPermissionCore extends EntityPermissionCoreBase {

}